module.exports = __webpack_public_path__ + "static/img/icon_wodegz@2x.a59e108a.png";